import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from '../../Utils/Icon';
import Loader from '../../Utils/Loader';

import classes from './styles.module.css';

function TerminalsFilters({ onApplyFilters, isLoading }) {
    const [filters, setFilters] = useState({
        active: true,
        inactive: false,
    });

    function apply() {
        const list = [];

        if (filters.active) list.push({ active: true });
        if (filters.inactive) list.push({ inactive: true });

        if (typeof onApplyFilters === 'function') {
            onApplyFilters(list);
        }
    }

    return (
        <div className={classes.Card}>
            <div className={classes.Body}>
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="TerminalsFilters.title" defaultMessage="Фильтры" />
                    </h6>

                    <div className={classes.Column}>
                        <div className={classes.CheckboxWrap}>
                            <input
                                id="terminals-active"
                                type="checkbox"
                                checked={filters.active}
                                onChange={(e) =>
                                    setFilters((prev) => ({ ...prev, active: e.target.checked }))
                                }
                            />
                            <label htmlFor="terminals-active" className={classes.CustomCheckbox}>
                                <div className={classes.ActiveIcon} />
                                <span>
                                    <FormattedMessage
                                        id="TerminalsFilters.status.active"
                                        defaultMessage="Активные"
                                    />
                                </span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input
                                id="terminals-inactive"
                                type="checkbox"
                                checked={filters.inactive}
                                onChange={(e) =>
                                    setFilters((prev) => ({ ...prev, inactive: e.target.checked }))
                                }
                            />
                            <label htmlFor="terminals-inactive" className={classes.CustomCheckbox}>
                                <div className={classes.BlockIcon} />
                                <span>
                                    <FormattedMessage
                                        id="TerminalsFilters.status.inactive"
                                        defaultMessage="Неактивные"
                                    />
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className={classes.Footer}>
                <button onClick={apply} className={classes.Submit} disabled={isLoading}>
                    {!isLoading ? (
                        <Icon className={classes.buttonIcon} icon="filter" size="17px" />
                    ) : (
                        <Loader isString={true} />
                    )}
                    <FormattedMessage id="ProjectsFilters.btn.filter" defaultMessage="Фильтровать" />
                </button>
            </div>
        </div>
    );
}

export default TerminalsFilters;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/TerminalsFilters/index.js